import * as React from 'react';

import { IconProps } from './Icon';

export function SlackIcon({ width, color }: IconProps): JSX.Element {
  const DEFAULT_WIDTH = '64';

  return (
    <svg
      fill="none"
      height={width || DEFAULT_WIDTH}
      viewBox="0 0 257 257"
      width={width || DEFAULT_WIDTH}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M54.0001,162 C54.0001,176.912 41.9121,189 27.0001,189 C12.0881,189 0.0001,176.912 0.0001,162 C0.0001,147.088 12.0881,135 27.0001,135 L54.0001,135 L54.0001,162 Z"
        fill="#E01E5A"
        id="Fill-9"
        mask="url(#mask-2)"
      />
      <path
        d="M67.5001,162 C67.5001,147.088 79.5881,135 94.5001,135 C109.4121,135 121.5001,147.088 121.5001,162 L121.5001,229.5 C121.5001,244.412 109.4121,256.5 94.5001,256.5 C79.5881,256.5 67.5001,244.412 67.5001,229.5 L67.5001,162 Z"
        fill="#E01E5A"
        id="Fill-10"
        mask="url(#mask-2)"
      />
      <path
        d="M94.5001,54 C79.5881,54 67.5001,41.912 67.5001,27 C67.5001,12.088 79.5881,0 94.5001,0 C109.4121,0 121.5001,12.088 121.5001,27 L121.5001,54 L94.5001,54 Z"
        fill="#36C5F0"
        id="Fill-11"
        mask="url(#mask-2)"
      />
      <path
        d="M94.5001,67.5 C109.4121,67.5 121.5001,79.588 121.5001,94.5 C121.5001,109.412 109.4121,121.5 94.5001,121.5 L27.0001,121.5 C12.0881,121.5 0.0001,109.412 0.0001,94.5 C0.0001,79.588 12.0881,67.5 27.0001,67.5 L94.5001,67.5 Z"
        fill="#36C5F0"
        id="Fill-12"
        mask="url(#mask-2)"
      />
      <path
        d="M202.5001,94.5 C202.5001,79.588 214.5881,67.5 229.5001,67.5 C244.4121,67.5 256.5001,79.588 256.5001,94.5 C256.5001,109.412 244.4121,121.5 229.5001,121.5 L202.5001,121.5 L202.5001,94.5 Z"
        fill="#2EB67D"
        id="Fill-13"
        mask="url(#mask-2)"
      />
      <path
        d="M189.0001,94.5 C189.0001,109.412 176.9121,121.5 162.0001,121.5 C147.0881,121.5 135.0001,109.412 135.0001,94.5 L135.0001,27 C135.0001,12.088 147.0881,0 162.0001,0 C176.9121,0 189.0001,12.088 189.0001,27 L189.0001,94.5 Z"
        fill="#2EB67D"
        id="Fill-14"
        mask="url(#mask-2)"
      />
      <path
        d="M162.0001,202.5 C176.9121,202.5 189.0001,214.588 189.0001,229.5 C189.0001,244.412 176.9121,256.5 162.0001,256.5 C147.0881,256.5 135.0001,244.412 135.0001,229.5 L135.0001,202.5 L162.0001,202.5 Z"
        fill="#ECB22E"
        id="Fill-15"
        mask="url(#mask-2)"
      />
      <path
        d="M162.0001,189 C147.0881,189 135.0001,176.912 135.0001,162 C135.0001,147.088 147.0881,135 162.0001,135 L229.5001,135 C244.4121,135 256.5001,147.088 256.5001,162 C256.5001,176.912 244.4121,189 229.5001,189 L162.0001,189 Z"
        fill="#ECB22E"
        id="Fill-16"
        mask="url(#mask-2)"
      />
    </svg>
  );
}
